import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./userSlice"
import alertReducer from "./alertSlice"
// import adminReducer from "./adminSlice"
import countryReducer from './CountrySlice'
import productReducer from './productSlice'
import stateReducer from './stateSlice'
import cityReducer from './citySlice'
import zipCodeReducer from './zipCodeSlice'
import userReducer from './userManagementSlice'
import patternReducer from './patternSlice'
import storeReducer from './StoreSlice'
import cmsReducer from './cmsSlice'
import badgeReducer from './badgeSlice'
import promotionsReducer from './promotionsSlice'
import supportTicketReducer from './supportSlice'
import inventoryReducer from './inventorySlice'
import settingReducer from './settingSlice'
import orderReducer from './orderSlice'
import dashboardReducer from './dashboardSlice'
import deliveryReducer from './delivaryPartnerSlice'
import notificationReducer from './notificationSlice'
import socialManagementReducer from './socialManagementSlice'



export const store = configureStore({
  reducer: {
    authSlice: authReducer,
    alert: alertReducer,
    country: countryReducer,
    product: productReducer,
    state: stateReducer,
    city: cityReducer,
    zipCode: zipCodeReducer,
    user: userReducer,
    pattern: patternReducer,
    store: storeReducer,
    cms: cmsReducer,
    badge: badgeReducer,
    promotions: promotionsReducer,
    supportTicket: supportTicketReducer,
    inventory: inventoryReducer,
    setting: settingReducer,
    order: orderReducer,
    dashboard: dashboardReducer,
    delivery: deliveryReducer,
    notification: notificationReducer,
    socialManagement: socialManagementReducer

    // adminSlice: adminReducer
  },
})